import { BrandMark } from '@/components/brand/BrandMark';
import { TopNav } from '@/components/hero/TopNav';
import { StatsRow } from '@/components/hero/StatsRow';
import { FooterBand } from '@/components/hero/FooterBand';
import { AccessCard } from '@/features/auth/AccessCard';

export function Landing() {
  return (
    <>
      <section className="hero">
        <header className="topbar">
          <BrandMark />
          <TopNav />
        </header>

        <main className="hero-body">
          <div className="left-block">
            <span className="kicker">
              <a
                href="https://aosenuma.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="kicker-brand-link"
              >
                aosenuma
              </a>
              {' · 2026'}
            </span>
            <h1>Proyecto arrendamiento de tierras</h1>
            <p className="lede">
              Plataforma de gestión, semaforización y reporte de{' '}
              <span className="accent">tierras</span> en tiempo real.
            </p>
            <StatsRow />
          </div>

          <div className="right-block">
            <AccessCard />
          </div>
        </main>
      </section>
      <FooterBand />
    </>
  );
}
